import { IconArrowUpRight } from "@tabler/icons-react";

export const UpRightButton = () => {
  return <IconArrowUpRight style={{ display: "inline" }} size={16} />;
};
